module.exports = __webpack_public_path__ + "img/jcnr4.2ca46b3d.png";